<div class="alert alert-warning" *ngIf="showReferralBlacklistOverlap">
  Du hast Kunden von ausgeschlossene Standorten ausgewählt.
</div>
